<template>
    <v-card elevation="0" class="grey lighten-4 pa-7">
        <v-card-text class="pa-1">
            <div>
                {{ this.customer.legal_name }}
            </div>

            <v-row no-gutters>
                <v-col>
                    <p class="headline text--primary">
                        {{ this.customer.trade_name }}
                    </p>
                </v-col>
                <v-col>
                    <div class="text-right subtitle-1">
                        <strong v-if="this.customer.cpf"
                            >{{ $t('customer.form.labels.cpf') }}:</strong
                        >
                        <strong v-else
                            >{{ $t('customer.form.labels.cnpj') }}:</strong
                        >

                        {{ this.customer.document }}
                    </div>
                </v-col>
            </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="d-flex">
            <span>
                <v-icon small left>mdi-phone</v-icon>
                {{ this.customer.phone }}
            </span>

            <v-divider class="mx-4" vertical></v-divider>

            <span>
                <v-icon small left>mdi-email</v-icon>
                {{ this.customer.email }}
            </span>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        customer: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style></style>
